module.exports = __webpack_public_path__ + "img/guide1.4fa4a3c1.png";